<template>
  <div class="loadingBox" v-if="$store.state.isShowLoading">
    <img src="../../assets/images/loading.gif" alt="" />
  </div>
</template>

<script>
export default {
  name: "Loading",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.loadingBox{
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #2e2c2c57;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
        width: 100px;
    }
}
</style>
